export class DataGrid {
  constructor(difference) {
    this.innerElement = "cxDataGrid"
    // 尺寸
    this.width = 500
    this.height = 300
    this.widthType = "px"
    this.heightType = "px"
    this.isSystemComponent = true
    this.isIndependenceComponent = true
    this.isDefaultComponent = true
    this.top = 10
    this.left = 10
    // 排列
    this.row = 1
    this.col = 1
    // 间距
    this.rowGap = 10
    this.columnGap = 20
    // 边框
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderStyle = "solid" // solid dashed dotted
    this.borderColor = "#000000"
    this.borderWidth = 1
    // 边距
    this.padding = 0
    this.paddingTop = 0
    this.paddingRight = 0
    this.paddingLeft = 0
    this.paddingBottom = 0
    // 更多
    this.opacity = 100
    this.boxShadowColor = "rgba(255,255,255,1)"
    this.boxShadowH = 0
    this.boxShadowV = 0
    this.boxShadowBlur = 0
    this.boxShadowSpread = 0
    // 底栏
    this.titleOptions = []
    this.cells = [{
      cellId: "root", // 只有第一个单元格允许编辑
      elementOptions: [], // 存放元素
      options: {
        width: 50,
        height: 200,
        widthType: "%",
        heightType: "px",
          // 背景
        bgColor: "rgb(255, 255, 255, 0)",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        color: "rgba(255,255,255,1)",
        textIsThemeColor: false,
        bgType: "自定义",
        bgColorIsThemeColor: false,
        // 边框
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderStyle: "solid", // solid dashed dotted
        borderColor: "#000000",
        borderWidth: 1,
        // 边距
        padding: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingLeft: 0,
        paddingBottom: 0,
        // 更多
        opacity: 100,
        boxShadowColor: "rgba(255,255,255,1)",
        boxShadowH: 0,
        boxShadowV: 0,
        boxShadowBlur: 0,
        boxShadowSpread: 0,
        overFlowType: "auto",
        detailsPageTarget: [] // 跳转详情页的相关参数
      }, // 存放挂载在单元格上的相关属性
    }] // 存放单元格数据，以及单元格内部元素
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
